import React, { Component } from 'react';

import { connect } from 'react-redux';
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple';
import Column from '~/Common-Objects/Grids/Column/Column';
import Icons from '~/Common-Objects/UI/Icons/index';
import Row from '~/Common-Objects/Grids/Row/Row';
import i18n from '~/i18n';
@connect((store) => {
    return { siteMaster: store.siteMaster }
})
class popPreviewForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: '100%'
        }
        this.changeView = this.changeView.bind(this)
    }

    changeView(view) {
        var views = ['100%', '768px', '480px']
        this.setState({
            width: views[view]
        })
    }

    render() {
        return (
            <Row className="emailPreviewHolder" margin={0}>
                <Column xs={12} className="mar-b25">
                    <div className="emailPreviewHolder-devices">
                        <div className="emailPreviewHolder-devices-toggle">
                            <ButtonSimple
                                toolTipFor="desktop"
                                className="button-simple-fullsize mar-r5"
                                selected={this.state.width === "100%" && "selected"}
                                onClick={() => { this.changeView(0) }}
                                tooltip="Desktop">
                                <Icons icon="monitor" color="#525150" />
                            </ButtonSimple>

                            <ButtonSimple
                                toolTipFor="tablet"
                                className="button-simple-fullsize mar-r5"
                                selected={this.state.width === "768px" && "selected"}
                                onClick={() => { this.changeView(1) }}
                                tooltip="Tablet">
                                <Icons icon="tabletOutline" color="#525150" />
                            </ButtonSimple>

                            <ButtonSimple
                                toolTipFor="mobile"
                                className="button-simple-fullsize "
                                selected={this.state.width === "480px" && "selected"}
                                onClick={() => { this.changeView(2) }}
                                tooltip="Mobile">
                                <Icons icon="mobileOutline" color="#525150" />
                            </ButtonSimple>
                        </div>
                    </div>
                </Column>


                <Column xs={12} margin={0} className="mar-b0">
                    <div className="innerPreviewHolder" style={{ maxWidth: this.state.width, margin: "0 auto" }}>
                        <iframe
                            width="100%" height="100%" style={{ border: "0" }} src={'https://' + this.props.siteMaster.trackingDomain + '/form?fid=' + this.props.FormId + '&am=' + this.props.AccountMasterId + '&host=true'}
                        />
                    </div >
                </Column >
            </Row>



        );
    }
}

export default popPreviewForm;
